require('./accountSettlementsFilter.scss');

const PropTypes = require('prop-types');

//vendor
const React = require('react');
//commons
const DateFilter = require('components/commons/dateFilter/dateFilter');
const OKModal = require('components/commons/OKModal/OKModal');

class AccountSettlementsFilter extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            dateSelected: props.immFilters.get('selected'),
            dateFrom: props.immFilters.get('from'),
            dateTo: props.immFilters.get('to')
        };

        this.handleApplyFilter = this.handleApplyFilter.bind(this);
        this.handleSetSelectedDate = this.handleSetSelectedDate.bind(this);
        this.handleSetDateFrom = this.handleSetDateFrom.bind(this);
        this.handleSetDateTo = this.handleSetDateTo.bind(this);
    }

    handleApplyFilter() {
        const { dateFrom, dateSelected, dateTo } = this.state;

        const newFilters = {
            dateSelected,
            dateFrom,
            dateTo
        };

        this.props.applyFilters(newFilters);
        this.props.onClose();
    }

    handleSetDateFrom(newDate) {
        this.setState({
            dateFrom: newDate
        });
    }

    handleSetDateTo(newDate) {
        this.setState({
            dateTo: newDate
        });
    }

    handleSetSelectedDate(selected) {
        this.setState({
            dateSelected: selected
        });
    }

    render() {
        const { immFilters, isOpen, onClose } = this.props;
        const contentModal = (
            <DateFilter
                showAnnual={false}
                showBiannual={false}
                showFortnightly={false}
                showThreeMonths={false}
                showMonthly={false}
                immFilter={immFilters}
                onChangeMax={this.handleSetDateTo}
                onChangeMin={this.handleSetDateFrom}
                onChangeSelected={this.handleSetSelectedDate}
            />
        );
        return (
            <OKModal 
                content={contentModal}
                footerType="navigation"
                isOpen={isOpen}
                primaryButtonText="common-apply"
                onCloseCallback={onClose}
                onPrimaryButtonClick={this.handleApplyFilter}
                onSecondaryButtonClick={onClose}
                secondaryButtonText="common-cancel"
                title="accountSettlementsFilter-title"
                type="filter"
            />
        );
    }
}

AccountSettlementsFilter.propTypes = {
    onClose: PropTypes.func.isRequired,
    applyFilters: PropTypes.func.isRequired,
    immFilters: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
};

module.exports = AccountSettlementsFilter;
